import React from 'react'

const Navbar = () => {
  return (
    <div className='flex items-center py-2 px-4 shadow bg-blue-500'>
      <p className='text-white text-lg font-semibold'>Kriyatus Admin</p>
    </div>
  )
}

export default Navbar